
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"panel.title":"Kompakte Ansicht","view.inMobileView.visible.hint":"In der kompakten Ansicht anzeigen"},"en":{"panel.title":"Compact view","view.inMobileView.visible.hint":"Show in compact view"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();